<template>
  <div class="container">
    <router-view></router-view>

    <h2 class="pt-5 mb-5 text-center">Welcome {{this.user.name}}</h2>
    <div class="dashboard-icons" v-show="ready">
      <div class="tile report" @click="reportWaste()">
        <h4 v-if="user.is_input">Submit<br />Waste</h4>
        <h4 v-else-if="isSectorAssociationRepresentative">Submit <br /> volume</h4>
        <h4 v-else>Submit product<br/>composition</h4>
        <br>
        <img v-if="isSectorAssociationRepresentative" src="../../../public/dashboard.svg" alt="" width="70px" height="70px">
        <img v-else src="../../../public/truck-icon.svg" alt="" width="70px" height="70px">
      </div>
      <div class="tile submissions" @click="manageSubmissions()">
        <h4 v-if="user.is_input || isRepresentative">Manage <br />Submissions</h4>
        <h4 v-else-if="isSectorAssociationRepresentative">Assign volume to region</h4>
        <h4 v-else>Manage Product<br/>composition submissions</h4>
        <br>
        <img v-if="isSectorAssociationRepresentative" src="../../../public/europe.svg" alt="" width="70px" height="70px">
        <img v-else src="../../../public/manage-submissions-icon.svg" alt="">
      </div>
      <div v-if="!isSectorAssociationRepresentative && !isRepresentative" class="tile compositions" @click="manageCompositions()">
        <h4 v-if="user.is_input">Manage<br />Waste Names</h4>
        <h4 v-else>Manage Product<br/>composition names</h4>
        <br>
        <img src="../../../public/manage-compositions-icon.svg" alt="">
      </div>
      <div class="tile account" @click="manageAccount()">
        <h4>Manage<br />Account</h4>
        <br>
        <img src="../../../public/manage-account-icon.svg" alt="">
      </div>
      <div v-if="!isSectorAssociationRepresentative" class="tile account" @click="$router.push({name: 'user.data-dashboard'})">
        <h4>Personalized<br/>Dashboard</h4>
        <br>
        <img src="../../../public/dashboard.svg" alt="">
      </div>
    </div>

    <!-- <div class="dashboard-icons" @click="manageUserApplications()">
      <div class="tile applications">
        <h4>Manage<br />applications</h4>
        <br>
        <img src="../../../public/manage-applications.svg" alt="">
      </div>
    </div> -->
    <hr>
    <div class="admin-section" v-if="isAdmin">
      <h3 class="mb-5">Admin section only (WIP)</h3>

      <div class="dashboard-icons">
        <div class="tile" @click="$router.push({name: 'user.manage-countries'})">
          <h4>Manage<br />countries</h4>
          <br>
          <img src="../../../public/raport-waste-icon.svg" alt="">
        </div>
        <div class="tile" @click="$router.push({name: 'user.manage-materials'})">
          <h4>Manage<br />materials</h4>
          <br>
          <img src="../../../public/manage-submissions-icon.svg" alt="">
        </div>
        <div class="tile" @click="$router.push({name: 'user.manage-applications'})">
          <h4>Assign end applications</h4>
          <br>
          <img src="../../../public/manage-compositions-icon.svg" alt="">
        </div>
        <div class="tile" @click="$router.push({name: 'user.manage-users'})">
          <h4>Manage<br />users</h4>
          <br>
          <img src="../../../public/raport-waste-icon.svg" alt="">
        </div>
      </div>

      <div class="dashboard-icons">
        <div class="tile" @click="$router.push({name: 'user.pages'})">
          <h4>Manage<br />pages</h4>
          <br>
          <img src="../../../public/raport-waste-icon.svg" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'AccountDashboard',

    data() {
      return {
        ready: false,
        publicPath: '../../../public/'
      };
    },

    computed: {
      ...mapGetters({
        user: 'user/user',
        isAdmin: 'user/isAdmin',
        isRepresentative: 'user/isRepresentative',
        isSectorAssociationRepresentative: 'user/isSectorAssociationRepresentative',
      }),
      // isAdmin() {
      //   return this.$store.getters['user/isAdmin'];
      // },
      login: {
        get () {
          return this.$store.getters['login/data'];
        },
        set (value) {
          this.$store.commit('login/data', value);
        }
      },
      // user () {
      //   return this.$store.getters['user/user'];
      // }
    },

    methods: {
      reportWaste () {
        // this.$store.dispatch('userCompanies/getCompanies', this.user.id);
        this.$store.dispatch('countries/getCountries');
        this.$store.dispatch('userSubmissions/current', deepCopy(this.$store.getters['userSubmissions/default']));
        if (this.isSectorAssociationRepresentative) {
          this.$router.push({name: 'user.new-submission-sector-association-representative'});
        } else {
          this.$router.push({name: 'user.new-submission'});
        }
      },
      // TODO remove unused components
      // reportWasteWizard () {
      //   // this.$store.dispatch('userCompanies/getCompanies', this.user.id);
      //   this.$store.dispatch('countries/getCountries');
      //   this.$store.dispatch('userSubmissions/current', deepCopy(this.$store.getters['userSubmissions/default']));
      //   this.$router.push('/submit-waste');
      // },
      manageCompositions () {
        this.$router.push({name: 'user.composition-list'});
      },
      manageUserApplications () {
        this.$router.push({name: 'user.applications'});
      },
      manageSubmissions () {
        if (this.isSectorAssociationRepresentative) {
          this.$router.push({name: 'user.manage-submission-sector-association-representative'});
        } else {
          this.$router.push({name: 'user.manage-submissions'});
        }
      },
      manageAccount () {
        this.$router.push({name: 'user.manage-account'});
      },
      getImage(name) {
        return '/img/' + name;
      }
    },

    mounted() {
      this.ready = true;
    }
  };

</script>
